enum Action {
  CREATE_SHIFTPLAN_MESSAGE = 'createShiftplanMessage',
  CREATE_SHIFTPLAN_NOTIFICATION = 'createShiftplanNotification',
}

export default Action;
